import { FC, ReactNode } from 'react';

import { defineMessages, useIntl } from 'dibs-react-intl';
import { SingleSelect } from 'dibs-elements/exports/SingleSelect';

import { PRICE_RANGE, FormData } from '../reducer';

type PriceRangeField = typeof PRICE_RANGE;
type PriceRangeValue = FormData[PriceRangeField];

import styles from './styles/IFramedPromoPartnershipPCForm.scss';

const messages = defineMessages({
    priceIsNoObject: {
        id: 'iFramedpromoPartnership.PriceRangeSelect.priceIsNoObject',
        defaultMessage: 'Price is no object',
    },
});

type Props = {
    value: PriceRangeValue;
    errorMessage: ReactNode;
    disabled?: boolean;
    setField: (field: PriceRangeField, value: PriceRangeValue) => void;
};

const PriceRangeSelect: FC<Props> = ({ value, errorMessage, disabled, setField }) => {
    const { formatMessage, formatNumber } = useIntl();
    const numberFormatOptions = {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
    };

    const getFinAmount = (number: number): string => formatNumber(number, numberFormatOptions);

    const selectOptions = [
        {
            value: '$5,000 or less',
            label: `<${getFinAmount(5000)}`,
        },
        {
            value: '$5,001 - $25,000',
            label: `${getFinAmount(5001)} - ${getFinAmount(25000)}`,
        },
        {
            value: '$25,001 - $50,000',
            label: `${getFinAmount(25001)} - ${getFinAmount(50000)}`,
        },
        {
            value: '$50,001 - $100,000',
            label: `${getFinAmount(50001)} - ${getFinAmount(100000)}`,
        },
        {
            value: 'Price is no object',
            label: formatMessage(messages.priceIsNoObject),
        },
    ];

    return (
        <div className={styles.field}>
            <SingleSelect
                dataTn="promo-partnership-price-range-select"
                name="promo-partnership-price-range"
                placeholder="What is your price range?"
                hasAnimatedPlaceholder
                value={value}
                onChange={option => setField(PRICE_RANGE, option?.value || '')}
                options={selectOptions}
                disabled={disabled}
                errorMessage={errorMessage}
                hasError={!!errorMessage}
            />
        </div>
    );
};

export default PriceRangeSelect;
